const state = {
	products: [],
	filterProds: [],
	filterDist: [],
	filters: [],
	selected: {},
	breadcrumbs: [],
	categories: [],
	tags: [],
	page: 1,
	pageLimit: 40,
	maxPage: 0,
	grid: '',
	isSelected: false,
	street: false,
	categoryID: 0
};

const mutations = {
	setProducts: (state, payload) => {
		state.products.push(...payload)		
	},
	setCategoryID: (state, payload) => {
		state.categoryID = payload	
	},
	setTags: (state, payload) => {
		const tags = payload
		tags.splice(-1)
		state.tags = tags
	},
	setFilters: (state, payload) => {	
		let data = payload
		if( data && data.Year){			
			data.Year = data.Year.reverse()			
		}
		state.filters = data
	
	},
	setCategories: (state, payload) => {
		state.categories = payload
	},
	setAltitude: (state, payload) => {
		state.selected.Altitude = payload
	},
	setSelected: (state, payload) => {
		state.selected = payload
	},
	setGrid: (state, payload) => {
		state.grid = payload
	},
	setBreadcrumbs: (state, payload) => {
		state.breadcrumbs = payload
	},
	setPage: (state, payload) => {
		if (payload < 1) {
			state.page = 1
		} else if (payload >= state.maxPage) {
			state.page = state.maxPage
		} else {
			state.page = payload
		}
	},
	setPageLimit: (state, payload) => {
		state.pageLimit = payload
	},
	setStreet: (state, payload) => { 
		state.street = payload 
	},
	setMax: (state) => {
		state.maxPage = Math.ceil(state.filterProds.length / state.pageLimit)
	},
	filterSelected: (state, payload) => {
		const key = payload[0]
		const val = payload[1]
		if (state.selected[key].includes(val)) {
			state.selected[key] = state.selected[key].filter((item) => item !== val);
		} else {
			state.selected[key].push(val);
		}
		const selected = {}
		selected['selected'] = state.selected
		selected['categoryID'] = state.categoryID
		if(Object.keys(state.selected).reduce((sum, item) => sum + state.selected[item].length , 0) > 0){
			localStorage.setItem('selected',  JSON.stringify(selected));
		}else{
			localStorage.removeItem('selected');
		}
		
	},
	setFilterProds: (state) => {
		const keys = Object.keys(state.selected)
		const prods = state.filterDist.filter(product => {
			let item = true
			keys.forEach(key => {
				if (key === 'category') {
					// state.selected[key].some(item => {
					// 	Object.keys(product.filters).includes(item)
					// })
					if (state.selected[key].length > 0 && state.selected[key].some(item => product.filters[item] === 'No')) {
						item = false
					}
				} else if (key === 'Altitude' && product.filters[key]) {
					if (state.selected[key] && !checkSize(state.selected[key][0], state.selected[key][1], product.filters[key])) {
						item = false
					}
				} else if (key === 'media') {
					if (state.selected[key].length > 0 && state.selected[key][0] && product.filters[state.selected[key][0]] === 'No' || state.selected[key][1] && product.filters[state.selected[key][1]] === 'No') {
						item = false
					}
				} else {
					if (state.selected[key].length > 0 && !state.selected[key].includes(product.filters[key])) {
						item = false
					}
				}
			});
			return item
		})
		state.filterProds = prods
	},
	resetFilters: (state) => {	
		Object.keys(state.selected).forEach(item => state.selected[item] = [])
	},
	setFilterDist: (state, payload) => {
		state.filterDist = payload
	},
	setIsSelected: (state) => {
		Object.keys(state.filters).forEach(item => {
			state.filters[item].forEach(item => {
				if (item.selected === '1') {
					state.isSelected = true
					return
				}
			})
		})
	},
	sortProducts: (state, payload) => {
		if (payload === 'name') {
			state.filterProds.sort((a, b) => {
				const nameA = a.name.toUpperCase();
				const nameB = b.name.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
			})
		}else if(payload === 'oldest'){
			state.filterProds.sort((a, b) => {
				const nameA = new Date(a.date).getTime();
				const nameB = new Date(b.date).getTime();
				return nameA - nameB
			})
		}else{
			state.filterProds.sort((a, b) => {
				const nameA = new Date(a.date).getTime();
				const nameB = new Date(b.date).getTime();
				return nameA - nameB
			}).reverse()
		}
	}
};

function checkSize(min, max, prod) {
	return +min < +prod && +prod < +max
}
const getters = {
	// categories: (state) => {
	// 	return state.filters.filter(item => item.name === 'Categoreis')[0];
	// },
	selected: (state) => {
		return Object.keys(state.selected).reduce((sum, item) => sum + state.selected[item].length , 0)
	},
	products: (state) => {
		return state.filterProds.filter((item, index) => {
			return (state.page - 1) * state.pageLimit <= index && index < state.page * state.pageLimit
		});
	}
};
const actions = {
	filterProducts({
		commit
	}, payload) {
		commit('filterSelected', payload)
		commit('setFilterProds')
		commit('sortProducts')
		commit('setMax')
		commit('setPage', 1)
	},
	resetProducts({
		commit
	}) {
		commit('resetFilters')
		commit('setFilterProds')
		commit('sortProducts')
		commit('setMax')
		commit('setPage', 1)
	},
	filterDist({
		commit
	}, payload) {
		commit('setFilterDist', payload)
		commit('setFilterProds')
		commit('sortProducts')
		commit('setMax')
		commit('setPage', 1)
	},
	applySlider({
		commit
	}) {
		commit('setFilterProds')
	},
	fillterStreet({commit}, payload) {
		commit('setStreet', payload)
	},
	filterCords({commit, state, rootState}) {
		let filter = state.products
		if(rootState.map.searchCord.lat && rootState.map.searchCord.lat) {
			const current = new google.maps.LatLng(
				rootState.map.searchCord.lat,
				rootState.map.searchCord.lng
			);
			filter = state.products
			  .filter((item) => {
				const marker = new google.maps.LatLng(+item.lat, +item.lng);
				item.distance = (
				  google.maps.geometry.spherical.computeDistanceBetween(
					current,
					marker
				  ) / 1000
				).toFixed(2);
				if (+item.distance < rootState.map.radius / 1000) {
				  return item;
				}
			  })
			  .sort((a, b) => a.distance - b.distance);
		}
		
		  commit('setFilterDist', filter)
		  commit('setFilterProds')
		  commit('sortProducts')
		  commit('setMax')	
		  commit('setPage', 1)
	  },
	  setProducts({commit, dispatch}, payload) {
		commit('setProducts', payload)
		dispatch('filterCords')	
		// commit('setFilterDist', payload)
		// commit('setFilterProds')
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};